// extracted by mini-css-extract-plugin
export default {"wrapper":"SingleContainer_wrapper__e8EDH","content":"SingleContainer_content__AqBzD","title":"SingleContainer_title__wI1VN"};